import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { OrganizationService } from "@onsip/common/services/api/resources/organization/organization.service";
import { map } from "rxjs";

enum DomainType {
  sipDomain,
  privateDomain
}

@Component({
  selector: "onsip-migrate-sip-domain-view",
  templateUrl: "./migrate-sip-domain-view.component.html",
  styleUrls: ["./migrate-sip-domain-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MigrateSipDomainViewComponent implements OnInit {
  @Output() editPanel = new EventEmitter<void>();
  defaultDomain = ".onsip.com";
  domainType = DomainType;
  viewData$ = this.organizationService.organization.pipe(
    map(org => {
      const oldDomain = org.domain;
      const domainName = org.domain.slice(0, org.domain.indexOf(this.defaultDomain));
      const domainType = oldDomain.includes(this.defaultDomain)
        ? DomainType.sipDomain
        : DomainType.privateDomain;
      return {
        domainType,
        domainName:
          domainType === DomainType.sipDomain ? domainName + this.defaultDomain : org.domain
      };
    })
  );

  togglePanel() {
    this.editPanel.emit();
  }

  ngOnInit(): void {
    this.organizationService.organizationBrowse();
  }

  constructor(private organizationService: OrganizationService) {}
}
